import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useTranslation as useI18nTranslation } from 'next-i18next';

import type { TFunction } from '@i18n/types';

const emptyT = (() => '') as TFunction;

const useTranslation = () => {
    const { t: i18nT, ready, i18n: i18nInstance } = useI18nTranslation(['translations']);

    const memoizedT = useCallback(
        (str: string, interpolations?: Record<string, any>) => {
            /* i18next-extract-disable-next-line */
            return i18nT(str || '', { ...interpolations }) as string;
        },
        [i18nT]
    ) as typeof i18nT;

    return {
        currentLanguage: i18nInstance.language,
        t: ready ? memoizedT : emptyT,
        ready,
        i18n: i18nInstance
    };
};

export default useTranslation;
